import { lazy, Suspense } from "react";
import { Classroom } from "./Classroom";

const Settings = lazy(() => import("./Settings").then((module) => ({ default: module.Settings })));
const Evaluation = lazy(() =>
  import("./Evaluation").then((module) => ({ default: module.Evaluation })),
);

export function App() {
  const isSettings = window.location.pathname === "/settings";
  const isEvaluation = window.location.pathname === "/evaluation";
  const isOperator = isSettings || isEvaluation;
  // The learner's classroom is a full-screen call: no site header or footer around the stage.
  if (!isOperator)
    return (
      <>
        <a className="skip-link" href="#main">
          본문 바로가기
        </a>
        <main id="main" className="learner-page">
          <Classroom />
        </main>
      </>
    );
  return (
    <>
      <a className="skip-link" href="#main" lang="en">
        Skip to content
      </a>
      <header className="app-header" lang="en">
        <a className="wordmark" href="/" aria-label="LiveAvatar Classroom home">
          <span className="brand-mark" aria-hidden="true">
            la
          </span>
          LiveAvatar<span className="wordmark-detail">Classroom</span>
        </a>
        <nav aria-label="Operator">
          <a href="/settings" aria-current={isSettings ? "page" : undefined}>
            Settings
          </a>
          <a href="/evaluation" aria-current={isEvaluation ? "page" : undefined}>
            Evaluation
          </a>
          <a href="/">Open classroom</a>
        </nav>
      </header>
      <main id="main" className="page" lang="en">
        <Suspense fallback={<p role="status">Opening workspace…</p>}>
          {isSettings ? <Settings /> : <Evaluation />}
        </Suspense>
      </main>
      <footer className="app-footer" lang="en">
        <span>AI instructor · Korean lessons</span>
        <span>Operator workspace</span>
      </footer>
    </>
  );
}
